import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type EmailDocumentsPageQueryVariables = Types.Exact<{
  publicId: Types.Scalars["String"];
  options?: Types.InputMaybe<Types.EmailDocumentsListOptions>;
}>;

export type EmailDocumentsPageQuery = {
  __typename?: "Query";
  emailDocumentsPage: {
    __typename?: "EmailDocumentsList";
    total: number;
    items: Array<{
      __typename?: "EmailDocument";
      id: string;
      filename: string;
      url: string;
      name?: string | null;
      amount?: number | null;
      currency?: string | null;
      documentNumber?: string | null;
      date?: string | null;
      createdAt: string;
      uploadSource: Types.DocumentUploadSource;
      documentOrigin?: string | null;
      matchStatus?: Types.DocumentMatchStatus | null;
      transactionId?: string | null;
      correctionData?: {
        __typename?: "EmailDocumentCorrectionData";
        name?: string | null;
        amount?: number | null;
        currency?: string | null;
        documentNumber?: string | null;
        date?: string | null;
        description?: string | null;
      } | null;
    }>;
  };
};

export const EmailDocumentsPageDocument = gql`
  query emailDocumentsPage(
    $publicId: String!
    $options: EmailDocumentsListOptions
  ) {
    emailDocumentsPage(publicId: $publicId, options: $options) {
      items {
        id
        filename
        url
        name
        amount
        currency
        documentNumber
        date
        createdAt
        uploadSource
        documentOrigin
        matchStatus
        transactionId
        correctionData {
          name
          amount
          currency
          documentNumber
          date
          description
        }
      }
      total
    }
  }
`;

/**
 * __useEmailDocumentsPageQuery__
 *
 * To run a query within a React component, call `useEmailDocumentsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailDocumentsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailDocumentsPageQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useEmailDocumentsPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    EmailDocumentsPageQuery,
    EmailDocumentsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EmailDocumentsPageQuery,
    EmailDocumentsPageQueryVariables
  >(EmailDocumentsPageDocument, options);
}
export function useEmailDocumentsPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EmailDocumentsPageQuery,
    EmailDocumentsPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EmailDocumentsPageQuery,
    EmailDocumentsPageQueryVariables
  >(EmailDocumentsPageDocument, options);
}
export type EmailDocumentsPageQueryHookResult = ReturnType<
  typeof useEmailDocumentsPageQuery
>;
export type EmailDocumentsPageLazyQueryHookResult = ReturnType<
  typeof useEmailDocumentsPageLazyQuery
>;
export type EmailDocumentsPageQueryResult = Apollo.QueryResult<
  EmailDocumentsPageQuery,
  EmailDocumentsPageQueryVariables
>;
